import {
  BOARD_STAGES,
  DEFAULT_BOARD_RANGE_DAYS,
  boardWindow,
  toBoardStages,
  useBoardDays,
  useDeliveryFlow,
} from '@features/dispatch';

/**
 * The board days and flow columns the overview reads. Same query keys as the
 * dispatch board, so an open dispatch page means a cache hit. Mount only
 * under `dispatch:read`: neither query has its own permission switch.
 */
export function useOverviewBoard(today: string) {
  const flow = useDeliveryFlow();
  const rangeDays = flow.data?.board_range_days ?? DEFAULT_BOARD_RANGE_DAYS;
  const columns = flow.data ? toBoardStages(flow.data.columns) : BOARD_STAGES;
  const board = useBoardDays(boardWindow(today, today, rangeDays), !flow.isLoading);
  return { board, columns };
}
